export enum NotificationTypeEnum {
    VideoCallInvite = "videoCallInvite",
    VideoCallInviteAccept = "videoCallInviteAccept",
    VideoCallInviteReject = "videoCallInviteReject",
    VideoCallCancelled = "videoCallCancelled",
    FamilyBroadcast = "familyBroadcast",
    FamilyNotification = "familyNotification",
    ServiceRequestStatusChanged = "serviceRequestStatusChanged",
    FamilyHasApprovedServiceRequest = "familyHasApprovedServiceRequest",
    FamilyHasRejectedServiceRequest = "familyHasRejectedServiceRequest",
    FamilyHasPurchasedServiceRequest = "familyHasPurchasedServiceRequest",
    Message = "message",
    ServiceApproval = "serviceApproval",
    ServiceRequest = "serviceRequest",
    VisitCreated = "visitCreated",
    VisitCancel = "visitCancel",
    Call = "call",
    EventAttendance = "eventAttendance",
    ConciergeEventScheduled = "conciergeEventScheduled",
    FriendRequest = 'friendRequest',
    MailingList = "mailingList",
    ServiceRequestCreated = "serviceRequestCreated",
    ServiceRequestCompleted = "serviceRequestCompleted",
    UnattendedEventEnded = "unattendedEventEnded",
    MaintenanceRequestCreated = "maintenanceRequestCreated",
    DeviceAssigned = "deviceAssigned",
    DeviceUnassigned = "deviceUnassigned",
    BookingsAndOrdersComment = 'bookingsAndOrdersComment',
    StaffAppResidentUpcomingCall = 'staffAppResidentUpcomingCall',
    StaffAppResidentUpcomingEvent = 'staffAppResidentUpcomingEvent',
    StaffAppResidentIncomingRequest = 'staffAppResidentIncomingRequest',
    StaffAppResidentTodaysBirthday = 'staffAppResidentTodaysBirthday',
    StaffAppResidentSuggestedUserStory = 'staffAppResidentSuggestedUserStory',
  }